import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardActionArea,
  Box
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

// Fallback avatar image (replace with your own placeholder if needed)
const fallbackAvatar = 'https://via.placeholder.com/300x200?text=No+Image';

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 300,
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[3],
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: theme.shadows[8]
    },
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden' // Ensure rounded corners apply to children
  },
  media: {
    height: 270,
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    backgroundColor: theme.palette.grey[200], // Fallback background for loading
    borderTopLeftRadius: theme.spacing(2),
    borderTopRightRadius: theme.spacing(2)
  },
  content: {
    padding: theme.spacing(2),
    textAlign: 'center'
  },
  name: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1)
  },
  title: {
    color: theme.palette.text.secondary,
    fontSize: '0.9rem'
  }
}));

const MemberCard = ({ member }) => {
  const history = useHistory();
  const classes = useStyles();

  return (
    <Card
      className={classes.card}
      onClick={() => history.push(`/members/${encodeURIComponent(member.name)}`)}
    >
      <CardActionArea>
        <CardMedia
          component="img"
          className={classes.media}
          image={member.avatar || fallbackAvatar}
          alt={member.name}
        />
        <CardContent className={classes.content}>
          <Typography variant="h6" className={classes.name}>
            {member.name}
          </Typography>
          <Typography variant="subtitle2" className={classes.title}>
            {member.title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

MemberCard.propTypes = {
  member: PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    avatar: PropTypes.string // Updated from avartar
  }).isRequired
};

export default MemberCard;